import React from 'react';
import { Box, UnorderedList, ListItem } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const MembershipPromoBannerDefaultText = ({ defaultTextConditions, t }) => {
  const {
    hasMemberGift,
    hasUserCredits,
    hasMembershipTiers,
    hasMemberPoints,
    defaultMembershipPromoBanner: {
      birthday_gifts,
      birthday_credits,
      earn_points_from_order,
      membership_tier_discount,
      welcome_credits,
    },
  } = defaultTextConditions;

  const hasWelcomeCredits = hasUserCredits && welcome_credits > 0;
  const hasBirthdayGift = hasMemberGift && birthday_gifts;
  const hasBirthdayCredits =
    !hasMemberGift && hasUserCredits && birthday_credits;
  const hasMembershipDiscount = hasMembershipTiers && membership_tier_discount;
  const hasEarnPoints = hasMemberPoints && earn_points_from_order;

  if (
    !hasWelcomeCredits &&
    !hasBirthdayGift &&
    !hasBirthdayCredits &&
    !hasMembershipDiscount &&
    !hasEarnPoints
  ) {
    return <span>{t('Default Text No Condition')}</span>;
  }

  return (
    <Box
      gap="8px"
      display="flex"
      flexDirection="column"
      padding="0 0 24px 0"
      color="#888888"
    >
      <Box>{t('Default Text Title')}</Box>
      <UnorderedList ml="20px">
        {hasWelcomeCredits && (
          <ListItem>
            {t('Default Text Welcome Credits', {
              amount: welcome_credits,
            })}
          </ListItem>
        )}
        {hasBirthdayGift && (
          <ListItem>{t('Default Text Birthday Gift')}</ListItem>
        )}
        {hasBirthdayCredits && (
          <ListItem>{t('Default Text Birthday Credits')}</ListItem>
        )}
        {hasMembershipDiscount && (
          <ListItem>{t('Default Text Membership Tier Discount')}</ListItem>
        )}
        {hasEarnPoints && (
          <ListItem>{t('Default Text Earn Points From Order')}</ListItem>
        )}
        <ListItem>{t('Default Text Desc')}</ListItem>
      </UnorderedList>
    </Box>
  );
};

MembershipPromoBannerDefaultText.propTypes = {
  defaultTextConditions: PropTypes.shape({
    hasMemberGift: PropTypes.bool,
    hasUserCredits: PropTypes.bool,
    hasMembershipTiers: PropTypes.bool,
    hasMemberPoints: PropTypes.bool,
    defaultMembershipPromoBanner: PropTypes.shape({
      birthday_gifts: PropTypes.bool,
      birthday_credits: PropTypes.bool,
      earn_points_from_order: PropTypes.bool,
      membership_tier_discount: PropTypes.bool,
      welcome_credits: PropTypes.number,
    }),
  }),
  t: PropTypes.func,
};

export default MembershipPromoBannerDefaultText;
